import RedirectToV2 from 'components/atoms/RedirectToV2';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

export const PlanningV2Redirect: React.FC = () => (
  <RedirectToV2 to="/planning" />
);

export const RegisterEquipmentV2Redirect: React.FC = () => (
  <RedirectToV2 to="/registration/equipment" />
);

export const AnomalyV2Redirect: React.FC = () => <RedirectToV2 to="/anomaly" />;

export const InspectionChecklistReportV2Redirect: React.FC = () => (
  <RedirectToV2 to="/inspection-checklist/view/:id" />
);

export const FollowUpServicesV2Redirect: React.FC = () => (
  <RedirectToV2 to="/follow-up-services" />
);

export const FollowUpReportV2Redirect: React.FC = () => (
  <RedirectToV2 to="/follow-up-services/report/:id" />
);

export const ChecklistV2Redirect: React.FC = () => (
  <Switch>
    <Route path="/checklist/inspecao">
      <RedirectToV2 to="/inspection-checklist" />
    </Route>
    <Route path="/checklist/cadastrar">
      <RedirectToV2 to="/registration/checklist" />
    </Route>
    <Route>
      <RedirectToV2 to="/inspection-checklist" />
    </Route>
  </Switch>
);
